import { ConfigReportsView as Reports } from './Reports';
import { ConfigReportingView as Reporting } from './Reporting';
import { PaneContent } from './PaneContent';

Reports.PaneContent = PaneContent;

export default Reports;
export { Reporting }